import * as React from "react";
import { cn } from "@/lib/utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-[var(--fx-r-md)] border border-[var(--fx-ink-200)] bg-white px-3 py-2 text-sm text-[var(--fx-ink-900)] placeholder:text-[var(--fx-ink-500)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--fx-accent-500)] focus-visible:ring-offset-1 focus-visible:border-[var(--fx-accent-500)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "dark:bg-[var(--dk-surface)] dark:border-[var(--dk-border-2)] dark:text-[var(--dk-text)] dark:placeholder:text-[var(--dk-text-mute)]",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
